module.exports = __webpack_public_path__ + "img/instagram.png.19a77860.webp";